var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 14.393,
    viewBox: "0 0 16.001 14.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-input-box",
    d: "M677.232-8963.107h-2.821c-.261,0-.469,0-.469-.611s.207-.605.469-.605h.942v-11.912h-.942c-.261,0-.469-.027-.469-.64s.207-.624.469-.624h2.821c.264,0,.471.011.471.624s-.207.64-.471.64h-.94v11.912h.94c.264,0,.471-.007.471.605s-.2.611-.465.611Zm-.072-2.192v-1.5h9.4v-7h-9.4v-1.5h9.9a1,1,0,0,1,1,1v8a1,1,0,0,1-1,1Zm-2.695,0h-1.4a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1h1.406v1.5h-.906v7h.906v1.5Z",
    transform: "translate(-672.062 8977.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextInput);
export default __webpack_public_path__ + "static/media/TextInput.61496040.svg";
export { ForwardRef as ReactComponent };